import React, { useState } from "react";
import { DialogTitle, Dialog, Button, TextField } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import { CreateNewPoll } from "../../services/polls.service";
import { Msg } from "../../components";
import moment from "moment";

export const FormNewPoll = ({ open, setOpen, lastId }) => {
  const [title, setTitle] = useState();
  const [msg, setMsg] = useState({});
  const [options, setOptions] = useState([]);

  const addOption = () => {
    const myOptions = [...options];

    const getLastId = options.slice(-1)[0] && options.slice(-1)[0].id;

    myOptions.push({
      title: "",
      totalVotes: 0,
      id: getLastId + 1 || options.length + 1,
    });

    setOptions(myOptions);
  };

  const removeOption = (id) => {
    const myOptions = [...options.filter((opt) => opt.id !== id)];

    setOptions(myOptions);
  };

  const save = async (e) => {
    e.preventDefault();

    // get data inside inputs

    const myOptions = options.map((opt) => {
      const titleOptions = document.getElementsByName(`opt-${opt.id}`);

      titleOptions.forEach((titleOpt) => {
        opt.title = titleOpt.value;
      });

      return opt;
    });

    const data = {
      id: lastId + 1,
      title,
      totalVotes: 0,
      createdAt: moment().format(),
      options: myOptions,
    };

    try {
      await CreateNewPoll(data);

      setMsg({
        type: "success",
        content: "Enquete criada com sucesso",
        contained: true,
      });
    } catch (error) {
      console.log("error", error);

      setMsg({
        type: "error",
        content: "Algo deu errado. " + error,
        contained: true,
      });
    }
  };

  return (
    <Dialog
      fullWidth={true}
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="sm"
    >
      <DialogTitle id="simple-dialog-title">Nova enquete</DialogTitle>
      <form onSubmit={save} noValidate style={{ padding: "20px" }}>
        <TextField
          fullWidth
          onChange={(e) => setTitle(e.target.value)}
          name="title"
          label="Título da enquete"
        />
        <div
          style={{
            padding: "20px",
            backgroundColor: "#f5f5f5",
            margin: "30px 0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 style={{ marginRight: "10px" }}>Opções</h3>
            <AddIcon
              onClick={addOption}
              style={{ cursor: "pointer" }}
              color="primary"
            />
          </div>

          {options.map((opt) => (
            <div
              key={opt.id}
              style={{
                display: "flex",
                padding: "20px",
                width: "100%",
                alignItems: "flex-end",
              }}
            >
              <TextField
                fullWidth
                name={`opt-${opt.id}`}
                label={`Opção ${opt.id}`}
              />
              <DeleteIcon
                onClick={() => removeOption(opt.id)}
                color="secondary"
                style={{ marginLeft: "10px", cursor: "pointer" }}
              />
            </div>
          ))}
        </div>
        <div style={{ textAlign: "right" }}>
          {msg.content && (
            <Msg
              content={msg.content}
              contained={msg.contained}
              type={msg.type}
            />
          )}
          <Button variant="contained" type="submit" color="primary">
            Salvar
          </Button>
        </div>
      </form>
    </Dialog>
  );
};
